import { render, staticRenderFns } from "./ConfigDetailTableAgGridComponent.vue?vue&type=template&id=df435d04&scoped=true&"
import script from "./ConfigDetailTableAgGridComponent.vue?vue&type=script&lang=js&"
export * from "./ConfigDetailTableAgGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDetailTableAgGridComponent.vue?vue&type=style&index=0&id=df435d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df435d04",
  null
  
)

export default component.exports